// This is a synchronous action, hence
import { deepCopy } from "../../../constants";
import { setScreenDeepDiveWidgetData } from "../../../constants/commandCenterConstants";
import { resetDeepDiveDashboard } from "../../DeepDiveDashboard/DeepDiveDashboard";

// thunk will not interfere.
export const resetScreen = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_SCREEN", payload: null });
  };
};

export const setIsCompetitor = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_COMPETITOR",
      value: value,
    });
  };
};

export const setPersonalisationSettingsToScreenState = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PERSONALISATION_SETTINGS",
      value: value,
    });
  };
};

export const setScreenLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCREEN_LOADER",
      value: value,
    });
  };
};
export const setScreenRefreshEvent = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCREEN_REFRESH_EVENT",
      value: value,
    });
  };
};
export const setScreenSettingFlag = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCREEN_SETTING_FLAG",
      value: value,
    });
  };
};
export const setScreenPersonalizationFlag = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCREEN_PERSONALIZATION_FLAG",
      value: value,
    });
  };
};
export const setBrandsInScreen = (selectedBrands) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRANDS_IN_SCREEN",
      brands: selectedBrands,
    });
  };
};
export const setUpdatedSettingInScreen = (
  settings,
  propName,
  propValue,
  userBrands = null,
  objForTemporyWordFunctionality = null,
  graphConditions = null
) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SETTINGS_IN_SCREEN",
      operation: "ALL_CLEAR",
      settings: settings,
      propName: propName,
      propValue: propValue,
      userBrands: userBrands,
      objForTemporyWordFunctionality: objForTemporyWordFunctionality,
      graphConditions: graphConditions,
    });
  };
};

export const setDurationInScreen = (duration) => {
  return (dispatch) => {
    dispatch({ type: "SET_DURATION_IN_SCREEN", duration: duration });
  };
};
export const setSelectedDurationType = (selected_duration_type) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_DURATION_TYPE_IN_SCREEN",
      selected_duration_type: selected_duration_type,
    });
  };
};
export const setSelectedDurationTypeFlag = (selected_duration_type_flag) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_DURATION_TYPE_FLAG_IN_SCREEN",
      selected_duration_type_flag: selected_duration_type_flag,
    });
  };
};
export const setGlobalFiltersInScreen = (filters) => {
  return (dispatch) => {
    dispatch({ type: "SET_FILTERS_IN_SCREEN", filters: filters });
  };
};
export const setCategoryScreenFilters = (category_screen_filters) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CATEGORY_SCREEN_FILTERS",
      category_screen_filters: category_screen_filters,
    });
  };
};
export const setScreenUpdatedData = (updatedScreenData) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCREEN_UPDATED_DATA",
      updatedScreenData: updatedScreenData,
    });
  };
};

export const updateScreenApiCalledList = (widgetId, operation) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCREEN_API_CALLED_LIST",
      widgetId: widgetId,
      operation: operation,
    });
  };
};
export const setClearScreenWidgetGraphData = (
  sectionIndex,
  widgetIndex,
  operation,
  widget_id,
  isRefreshEvent,
  presistDataStored = false
) => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_SCREEN_WIDGET_GRAPH_DATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      operation: operation ? operation : "CLEAR",
      widget_id: widget_id,
      isRefreshEvent: isRefreshEvent,
      presistDataStored: presistDataStored,
    });
  };
};
export const setClearAllScreenWidgetGraphData = (
  widgetRefreshId,
  isRefreshEvent = false
) => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_ALL_SCREEN_WIDGET_GRAPH_DATA",
      operation: "ALL_CLEAR",
      isRefreshEvent: isRefreshEvent,
      widgetRefreshId: widgetRefreshId,
      globalChangeInprogress: isRefreshEvent ? !isRefreshEvent : true,
    });
  };
};
export const setTagcloudFilterPillValueInScreen = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_TAGCLOUD_FILTER_FILL_IN_SCREEN",
      tagcloud_filter_pill: value,
    });
  };
};
export const setTagcloudFilterPillInAllScreenWidget = (
  propName,
  propValue,
  operation
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_TAGCLOUD_FILTER_FILL_IN_ALL_SCREEN_WIDGET",
      operation: operation ? operation : "ALL_CLEAR",
      propName: propName,
      propValue: propValue,
    });
  };
};
// export const setDateAggregation = (
//   sectionIndex,
//   widgetIndex,
//   propName,
//   propValue
// ) => {
//   return (dispatch) => {
//     dispatch({
//       type: "SET_DATE_AGGREGATION",
//       operation: "CLEAR",
//       propName: propName,
//       propValue: propValue,
//       sectionIndex: sectionIndex,
//       widgetIndex: widgetIndex,
//     });
//   };
// };
export const setScreenWidgetResponseGraphData = (
  value,
  sectionIndex,
  widgetIndex,
  body,
  graphObject
) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCREEN_WIDGET_GRAPH_DATA",
      graphData: value,
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      operation: "UPDATE",
      body: body,
      graphObject: graphObject,
    });
  };
};
export const setScreenWidgetMetaData = (
  metadata,
  sectionIndex,
  widgetIndex,
  sectionId
) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCREEN_WIDGET_META_DATA",
      metadata: metadata,
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      operation: "UPDATE",
      sectionId: sectionId,
    });
  };
};

export const updateScreenWidgetPropdata = (
  sectionIndex,
  widgetIndex,
  updatedProp // it is {prop_name : "", prop_value:""}
) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCREEN_WIDGET_PROP_DATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      updatedProp: updatedProp,
    });
  };
};

export const setScreenIsDeepDive = (isDeepDive, deep_dive_object) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_DEEP_DIVE_IN_SCREEN",
      isDeepDive: isDeepDive,
      deep_dive: deep_dive_object,
    });
  };
};
export const setScreenIsDeepDiveDashboard = (isDeepDiveDashboard) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_DEEP_DIVE_DASHBOARD_IN_SCREEN",
      isDeepDiveDashboard: isDeepDiveDashboard,
    });
    if (isDeepDiveDashboard === false) {
      dispatch(resetDeepDiveDashboard());
    }
  };
};

export const setScreenDeepDiveData = (
  value,
  screen,
  widget_id,
  tabName,
  shareBrands,
  shareTemplateData
) => {
  let deep_dive_obj = {};
  if (widget_id === "info-bar") {
    if (shareBrands) {
      deep_dive_obj.infoBar = value;
    } else deep_dive_obj.infoBar = value;
  } else if (tabName === "Mentions") {
    if (widget_id === "1.1") {
      if (shareBrands) {
        deep_dive_obj.mentions = value;
      } else deep_dive_obj.mentions = value;
    } else if (widget_id === "1.2") {
      if (shareBrands) {
        deep_dive_obj.news_mentions = value;
      } else deep_dive_obj.news_mentions = value;
    }
  } else if (tabName === "Word Cloud") {
    value.widget_id = widget_id;
    if (shareBrands) {
      deep_dive_obj.wordcloud = setScreenDeepDiveWidgetData(
        value,
        screen,
        "wordcloud",
        shareBrands,
        shareTemplateData
      );
    } else
      deep_dive_obj.wordcloud = setScreenDeepDiveWidgetData(
        value,
        screen,
        "wordcloud",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Category") {
    if (shareBrands) {
      deep_dive_obj.category = setScreenDeepDiveWidgetData(
        value,
        screen,
        "category",
        shareBrands,
        shareTemplateData
      );
    } else
      deep_dive_obj.category = setScreenDeepDiveWidgetData(
        value,
        screen,
        "category",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Top Users") {
    if (shareBrands) {
      deep_dive_obj.top_users = setScreenDeepDiveWidgetData(
        value,
        screen,
        "top_users",
        shareBrands,
        shareTemplateData
      );
    } else
      deep_dive_obj.top_users = setScreenDeepDiveWidgetData(
        value,
        screen,
        "top_users",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Influencers") {
    if (shareBrands) {
      deep_dive_obj.influencers = setScreenDeepDiveWidgetData(
        value,
        screen,
        "influencers",
        shareBrands,
        shareTemplateData
      );
    } else
      deep_dive_obj.influencers = setScreenDeepDiveWidgetData(
        value,
        screen,
        "influencers",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Source of Post") {
    if (shareBrands) {
      deep_dive_obj.source_of_post = setScreenDeepDiveWidgetData(
        value,
        screen,
        "source_of_post",
        shareBrands,
        shareTemplateData
      );
    } else
      deep_dive_obj.source_of_post = setScreenDeepDiveWidgetData(
        value,
        screen,
        "source_of_post",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Location Profiles") {
    if (shareBrands) {
      deep_dive_obj.locations = setScreenDeepDiveWidgetData(
        value,
        screen,
        "locations",
        shareBrands,
        shareTemplateData
      );
    } else
      deep_dive_obj.locations = setScreenDeepDiveWidgetData(
        value,
        screen,
        "locations",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "TwitterTrends" || tabName === "GoogleTrends") {
    // # twitter-trends_1: Google Related Mentions,
    // # twitter-trends_2: Selected Brand Related Mentions,
    // # twitter-trends_3: Trendline of Mentions,
    // # twitter-trends_4: Wordcloud and related mentions
    let updatedTwitterTrend = {};
    if (widget_id === "twitter-trends_1") {
      updatedTwitterTrend.googleTrendResult = value;
    } else if (widget_id === "twitter-trends_2") {
      updatedTwitterTrend.brandRelatedMentions = value;
    } else if (widget_id === "twitter-trends_3") {
      updatedTwitterTrend.trendlineMentions = value; //value;
    } else if (widget_id === "twitter-trends_4") {
      updatedTwitterTrend.wordcloudMentions = value;
    }
    deep_dive_obj.twitter_trend = updatedTwitterTrend;
  }

  return (dispatch) => {
    dispatch({
      type:
        tabName === "TwitterTrends" || tabName === "GoogleTrends"
          ? "SET_DEEP_DIVE_DATA_IN_SCREEN_FOR_TWITTER_TREND"
          : "SET_DEEP_DIVE_DATA_IN_SCREEN",
      isDeepDive: true,
      deep_dive: deep_dive_obj,
    });
  };
};
export const setSelectedDeepdiveWidgetInScreen = (
  section_index,
  widget_index
) => {
  let selected_deepdive_widget = {
    section_index: section_index,
    widget_index: widget_index,
  };
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_DEEPDIVE_WIDGET_IN_SCREEN",
      selected_deepdive_widget: selected_deepdive_widget,
    });
  };
};
export const updateScreenWidgetPropdataWithClearGraphData = (
  sectionIndex,
  widgetIndex,
  updatedProp, // it is {prop_name : "", prop_value:""}
  isNeedToUpdateAllWidgetWithSameId,
  presistDataStored = false
) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCREEN_WIDGET_WITH_PROP_DATA_AND_CLEAR_GRAPHDATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      updatedProp: updatedProp,
      isNeedToUpdateAllWidgetWithSameId: isNeedToUpdateAllWidgetWithSameId,
      presistDataStored,
    });
  };
};

export const updateGlobePinToggle = (value) => {
  return (dispatch) => {
    dispatch({
      type: "ON_GLOBE_PIN_TOGGLE_CHANGE",
      globePinToggleValue: value,
    });
  };
};

export const setOnClickGlobeCoordinates = (data) => {
  return (dispatch) => {
    dispatch({
      type: "ON_CLICK_MENTION_GLOBE_ICON",
      data: data,
    });
  };
};

export const setLocationOnOff = (value) => {
  return (dispatch) => {
    dispatch({
      type: "ON_CLICK_LOCATION_ICON",
      data: value,
    });
  };
};

export const setWidgetXAxisAttribute = (widget_list, propName, propValue) => {
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_X_AXIS_ATTRIBUTE",
      widget_list: widget_list,
      propName: propName,
      propValue: propValue,
    });
  };
};

export const setStreamScreenBrand = (stream_screen_brand) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STREAM_SCREEN_BRAND",
      stream_screen_brand: stream_screen_brand,
    });
  };
};

export const setCurrentScreenBrand = (current_screen_brand) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CURRENT_SCREEN_BRAND",
      current_screen_brand: current_screen_brand,
    });
  };
};

export const setStreamScreenFilters = (stream_screen_filters) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STREAM_SCREEN_FILTERS",
      stream_screen_filters: stream_screen_filters,
    });
  };
};

export const setStreamScreenDefaultWidget = (stream_screen_default_widget) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STREAM_SCREEN_DEFAULT_WIDGET",
      stream_screen_default_widget: stream_screen_default_widget,
    });
  };
};
export const setOpenCampaignPopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_OPEN_CAMPAIGN_POPUP",
      value: value,
    });
  };
};
export const setCampaignProfileList = (profileList) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CAMPAIGN_PROFILE_LIST",
      value: profileList,
    });
  };
};
export const setCampaignQuickProfile = (quickProfile) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CAMPAIGN_QUICK_PROFILE",
      value: quickProfile,
    });
  };
};
export const setProfileListInScreen = (profiles) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PROFILE_LIST_IN_SCREEN",
      profiles: profiles,
    });
  };
};
export const setSelectedProfileInScreen = (selectedProfile) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_QUICK_PROFILE_IN_SCREEN",
      selectedProfile: selectedProfile,
    });
  };
};
export const setScreenCampaignDate = (duration) => {
  return (dispatch) => {
    dispatch({ type: "SET_SCREEN_CAMPAIGN_DATE", duration: duration });
  };
};
export const setGlobalChangeInprogress = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_GLOBE_CHANGE_INPROGRESS", value: value });
  };
};

export const setOnHoverStopTimeout = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_ON_HOVER_STOP_TIMEOUT", value: value });
  };
};

export const setGlobePlayAndPauseAnimation = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_GLOBE_PLAY_AND_PAUSE_ANIMATION",
      value: value,
    });
  };
};

export const setSignalRmentionDataForThreeDGlobeScreen = (data) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SIGNALR_MENTION_DATA_FOR_THREE_D_GLOBE_SCREEN",
      data: data,
    });
  };
};

export const setDateAggregationLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DATE_AGGREGATION_LOADER",
      value: value,
    });
  };
};
export const setAnimatedWidgetLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ANIMATED_WIDGET_LOADER",
      value: value,
    });
  };
};

export const setMarkInfluencersList = (markInfluencersList) => {
  return (dispatch) => {
    dispatch({
      type: "SET_MARK_INFLUENCERS_LIST",
      markInfluencersList: markInfluencersList,
    });
  };
};

export const setMarkInfluencersFlag = (markInfluencersFlag) => {
  return (dispatch) => {
    dispatch({
      type: "SET_MARK_INFLUENCERS_FLAG",
      markInfluencersFlag: markInfluencersFlag,
    });
  };
};

export const setDeletePostFlag = (deletePostFlag) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DELETE_POST_FLAG",
      deletePostFlag: deletePostFlag,
    });
  };
};
export const setScreenHeaderFilterPills = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SCREEN_HEADER_FILTER_PILLS", value: value });
  };
};
export const setScreenDataPoolingInprogress = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCREEN_DATA_POOLING_INPROGRESS",
      newData: value,
    });
  };
};
export const setScreenDataPool = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SCREEN_DATA_POOL", value: value });
  };
};

export const updateScreenDataPool = (operation, widget_id, value = null) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SCREEN_DATA_POOL",
      operation: operation,
      widget_id: widget_id,
      newData: value,
    });
  };
};
export const setPauseAnimationWhenPopupOpen = (value = false) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PAUSE_ANIMATION_WHEN_POPUP_OPEN",
      value: value,
    });
  };
};

export const setCountryStateCityLoader = (value = false) => {
  return (dispatch) => {
    dispatch({
      type: "SET_COUNTRY_STATE_CITY_LOADER",
      loader: value,
    });
  };
};

export const setCountryStateCityData = (value = []) => {
  return (dispatch) => {
    dispatch({
      type: "SET_COUNTRY_STATE_CITY_DATA",
      countryStateCityList: value,
    });
  };
};
export const setCountryStateCityFilters = (country_state_city_filters) => {
  return (dispatch) => {
    dispatch({
      type: "SET_COUNTRY_STATE_CITY_FILTERS",
      country_state_city_filters: country_state_city_filters,
    });
  };
};
export const setSelectedSearchedTopicOnScreen = (selectedSearchedTopic) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_SEARCHED_TOPIC",
      selectedSearchedTopic: selectedSearchedTopic,
    });
  };
};
export const setSearchedTopicLoader = (value = false) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SEARCHED_TOPIC_LOADER",
      loader: value,
    });
  };
};

export const setSearchedTopicList = (value = []) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SEARCHED_TOPIC_LIST",
      searchedTopicList: value,
    });
  };
};
